import { Button, EmptyState } from '@hemmafixa/ui';
import { Compass } from 'lucide-react';
import { Link } from 'react-router';
import { useI18n } from '@/i18n/context';

/** `standalone` for paths outside every area, where there is no app layout around it */
export function NotFoundPage({ standalone }: { standalone?: boolean }) {
  const { t } = useI18n();
  const page = (
    <EmptyState
      icon={Compass}
      title={t.common.notFoundTitle}
      titleAs="h1"
      description={t.common.notFoundText}
      action={
        <Button asChild variant="outline">
          <Link to="/">{t.common.goHome}</Link>
        </Button>
      }
    />
  );
  return standalone ? <main className="p-4">{page}</main> : page;
}
